export enum VWOEvents {
  CLICK_ON_GO_TO_CART = 'clickOnGoToCart',
  ADD_PRODUCT_TO_CART = 'addProductToCart',
}
export enum VWOVariations {
  GO_TO_CART_FOOTER_BUTTON = 'goToCartFooterButton',
  URGENCY_TRIGGER = 'urgencyTrigger',
}
